import { render, staticRenderFns } from "./Stock.vue?vue&type=template&id=8be06cb8&scoped=true&"
import script from "./Stock.vue?vue&type=script&lang=js&"
export * from "./Stock.vue?vue&type=script&lang=js&"
import style0 from "./Stock.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Stock.vue?vue&type=style&index=1&id=8be06cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be06cb8",
  null
  
)

export default component.exports